import styled from '@emotion/styled';
import { isSafeRedirectUrl } from '@zelos/shared/lib/redirect-util';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import ImageButton from '@/components/comm/ImageButton';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import facebook from '@/public/images/facebook.png';
import github from '@/public/images/github.png';
import google from '@/public/images/google.png';
import kakao from '@/public/images/kakao.png';

const Container = styled.div`
width: 100%;
margin-top: 60px;
margin-bottom: 50px;
`;

const Text = styled.p`
margin-bottom: 25px;
color: ${colors.textPrimary};
font-size: 13px;
font-weight: 500;
text-align: center;
`;

const SnsButtonsDiv = styled.div`
display: grid;
margin: 0px 20px;
grid-template-columns: 1fr 1fr 1fr 1fr;
justify-items: center;
@media (max-width: ${breakpointSmall}) {
  margin: 0px;
}
`;

const SnsText = styled.p`
margin-top: 4px;
color: ${colors.textPrimary};
font-size: 12px;
line-height: 150%;
text-align: center;
`;

const SnsSign = ({ text }: { text: string }) => {
  const router = useRouter();

  const destination = useMemo(() =>
    isSafeRedirectUrl(String(router.query.destination)) && String(router.query.destination),
  [router.query.destination]);

  return (
    <Container>
      <Text>{text}</Text>
      <SnsButtonsDiv>
        <form action="/api/v1/users/google/">
          {destination && (
            <input
              type="hidden"
              name="destination"
              value={destination}
            />
          )}
          <ImageButton
            type="submit"
            src={google}
            alt="sns login google"
            style={{ maxWidth: '50px', height: '50px' }}
          />
          <SnsText>Google</SnsText>
        </form>
        <form action="/api/v1/users/kakao/">
          {destination && (
            <input
              type="hidden"
              name="destination"
              value={destination}
            />
          )}
          <ImageButton
            type="submit"
            src={kakao}
            alt="sns login kakao"
            style={{ maxWidth: '50px', height: '50px' }}
          />
          <SnsText>Kakao</SnsText>
        </form>
        <form action="/api/v1/users/github/">
          {destination && (
            <input
              type="hidden"
              name="destination"
              value={destination}
            />
          )}
          <ImageButton
            type="submit"
            src={github}
            alt="sns login github"
            style={{ maxWidth: '50px', height: '50px' }}
          />
          <SnsText>Github</SnsText>
        </form>
        <form action="/api/v1/users/facebook/">
          {destination && (
            <input
              type="hidden"
              name="destination"
              value={destination}
            />
          )}
          <ImageButton
            type="submit"
            src={facebook}
            alt="sns login facebook"
            style={{ maxWidth: '50px', height: '50px' }}
          />
          <SnsText>Facebook</SnsText>
        </form>
      </SnsButtonsDiv>
    </Container>
  );
};

export default SnsSign;
